export default __webpack_public_path__ + "instagram.ce4ffee4.png";